import httpService from "./http.service";

class InstallmentService {
    getInstallments = () => {
        return httpService.get(`/installment/admin`);
    };
    createInstallment = (model) => {
        return httpService.form("/installment/admin", model);
    };
    editInstallment = (id, model) => {
        return httpService.form("/installment/admin/" + id, model, "editInstallment", {}, "patch");
    };

    createInstallmentQuestion = (installmentId, model) => {
        return httpService.post(`/installment/admin/question/${installmentId}`, model);
    };
    editInstallmentQuestion = (installmentId, id, model) => {
        return httpService.patch(`/installment/admin/question/${installmentId}/${id}`, model);
    };
    removeInstallmentQuestion = (installmentId, id) => {
        return httpService.delete(`/installment/admin/question/${installmentId}/${id}`);
    };
}

const installmentService = new InstallmentService();
export default installmentService;